import React, { useMemo } from 'react'
import './BluePrint.css'
import RichTextContent, { CmsText } from '../../../RichTextContent/RichTextContent'
import { useAboutSection } from '../../../../context/AboutPageContext'
import { getBlueprintCardsFromSection } from '../../../../services/contentApi'
import { resolveMediaUrl } from '../../../../utils/resolveMediaUrl'

import missionIcon from '../../../../assets/icons/about/icon1.svg'
import visionIcon from '../../../../assets/icons/about/icon2.png'
import simpleIcon from '../../../../assets/icons/about/icon3.png'
import speedIcon from '../../../../assets/icons/about/icon4.png'
import valueIcon from '../../../../assets/icons/about/icon5.png'

const icons = [missionIcon, visionIcon, simpleIcon, speedIcon, valueIcon]

const BluePrint = () => {
  const { section, loading } = useAboutSection('blueprint')

  const bgSrc = useMemo(() => {
    const url = section?.media?.primary?.url
    return url ? resolveMediaUrl(url) : ''
  }, [section])

  if (loading || !section?.fields) return null

  const fields = section.fields
  const cards = getBlueprintCardsFromSection(section, 5)
  const largeCards = cards.slice(0, 2)
  const smallCards = cards.slice(2, 5)

  return (
    <section className="blueprint">
      <div className="bp-header">
        {fields.subtitle ? (
          <CmsText
            content={fields.subtitle}
            as="p"
            className="bp-subtitle"
          />
        ) : null}

        {fields.title ? (
          <CmsText content={fields.title} as="h2" className="bp-title" />
        ) : null}

        {fields.description ? (
          <RichTextContent
            content={fields.description}
            className="bp-description"
          />
        ) : null}
      </div>

      <div className="bp-bg">
        {bgSrc ? <img src={bgSrc} alt="" /> : null}
      </div>

      <div className="bp-cards">
        {largeCards.map((card, i) => (
          <div className="bp-card large" key={i}>
            <img src={icons[i]} alt="" className="bp-icon" />
            <h3>
              {card.label ? (
                <CmsText content={card.label} as="span" />
              ) : null}{' '}
              {card.title ? (
                <CmsText content={card.title} as="span" />
              ) : null}
            </h3>
            <RichTextContent content={card.description} />
          </div>
        ))}

        {smallCards.map((card, i) => (
          <div className="bp-card small" key={i + 2}>
            <img src={icons[i + 2]} alt="" className="bp-icon" />
            {card.title ? (
              <CmsText content={card.title} as="h4" />
            ) : null}
            <RichTextContent content={card.description} />
          </div>
        ))}
      </div>
    </section>
  )
}

export default BluePrint
